import { AdvancedFilterItem } from '../../common/deprecated-advanced-filter/DeprecatedAdvancedFilter';

export const advancedFilterItemsToCanvasFilterItemsData = (
  items: AdvancedFilterItem<any>[],
): { label: string; value: string; data: any }[] =>
  items.map(({ value, label, data }) => ({ value, label, data }));
